import React from 'react'
import { compose } from 'recompose'
import withData from '../../../elements/Select/withData'
import { isEmpty, uniq } from 'lodash'
import withKeyValue from '../../../elements/HOC/WithKeyValue'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import { Link } from 'react-router-dom'
import DateCell from '../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { Button } from 'antd'

VouchersLinesList.propTypes = {}

function getStatusSelect(list) {
  return compose(withData({ data: uniq(list.map((l) => l.status)) }), withKeyValue(), withSort)(CustomSelect)
}

function getPaymentStatusSelect(list) {
  return compose(withData({ data: uniq(list.map((l) => l.paymentStatus)) }), withKeyValue(), withSort)(CustomSelect)
}

function filterArraySelect(filter, row) {
  if (isEmpty(filter.value)) return true
  return filter.value.includes(row[filter.id])
}

function VouchersLinesList(props) {
  const { fetchingLines, fetchLines, listLines, companyLines, onChangeCompanyLines } = props
  const StatusSelect = React.useMemo(() => getStatusSelect(listLines), [listLines.length])

  const PaymentStatusSelect = React.useMemo(() => getPaymentStatusSelect(listLines), [listLines.length])

  const columns = [
    { Header: 'ID', accessor: '_id', hideable: true, hideDefault: true },
    { Header: 'No', accessor: 'no' },
    { Header: 'Name', accessor: 'name' },

    {
      Header: 'Code',
      accessor: 'voucher.code',
      width: 200,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/purchasing/vouchers/${original.voucher._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },

    { Header: 'Claim Date', accessor: 'voucher.billDate', Cell: DateCell },
    {
      Header: 'Voucher Date',
      accessor: 'voucher.date',
      Cell: DateCell,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Due Date',
      accessor: 'voucher.dueDate',
      Cell: DateCell,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Vendor',
      accessor: 'voucher.payee.fn',
      hideDefault: true,
      hideable: true,
    },
    { Header: 'Type', accessor: 'voucher.type' },
    {
      Header: 'Order',
      accessor: 'voucher.order.code',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Contract',
      accessor: 'voucher.contract.code',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Company',
      accessor: 'voucher.company.fn',
      width: 300,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Bank',
      accessor: 'voucher.bank.accname',
      hideDefault: true,
      hideable: true,
    },
    { Header: 'Currency', accessor: 'voucher.currency' },
    { Header: 'Unit', accessor: 'unit' },
    { Header: 'Gross', accessor: 'amount.gross', Cell: MoneyCell },
    { Header: 'Tax', accessor: 'amount.tax', Cell: MoneyCell },
    { Header: 'Net', accessor: 'amount.net', Cell: MoneyCell },
    {
      Header: 'Tax Type',
      accessor: 'tax.type',
    },
    {
      Header: 'Account',
      accessor: 'account.name',
    },
    {
      Header: 'Payment Status',
      accessor: 'voucher.paymentStatus',
      Cell: StatusCell,
      hideDefault: true,
      hideable: true,
      filterMethod: filterArraySelect,
      Filter: ({ onChange, filter }) => (
        <PaymentStatusSelect
          showSearch={false}
          onChange={(value) => onChange(value)}
          value={filter ? filter.value : []}
          mode="multiple"
        />
      ),
    },
    {
      Header: 'Status',
      accessor: 'voucher.status',
      Cell: StatusCell,
      filterMethod: filterArraySelect,
      hideDefault: true,
      hideable: true,
      Filter: ({ onChange, filter }) => (
        <StatusSelect
          showSearch={false}
          onChange={(value) => onChange(value)}
          value={filter ? filter.value : []}
          mode="multiple"
        />
      ),
    },
  ]

  console.log({ listLines})
  return (
    <CustomTable
      data={listLines}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetchingLines}
      fetch={fetchLines}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={companyLines}
          onChange={onChangeCompanyLines()}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: '/purchasing/vouchers/new/',
            })
          }}>
          New{' '}
        </Button>
      )}
      columns={columns}
    />
  )
}

export default VouchersLinesList
